"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleChangeIntegralsSumFlag = exports.handleChangeIntegralsRelativeValue = exports.handleChangeIntegral = exports.handleDeleteIntegral = exports.handleAddIntegral = exports.handleChangeIntegralSum = exports.handleCutIntegral = void 0;
const uuid_1 = require("@lukeed/uuid");
const immer_1 = require("immer");
const ml_spectra_processing_1 = require("ml-spectra-processing");
const Spectrum1D_1 = require("../../../data/data1d/Spectrum1D");
const SumManager_1 = require("../../../data/data1d/Spectrum1D/SumManager");
const getActiveSpectrum_1 = require("../helper/getActiveSpectrum");
const getRange_1 = __importDefault(require("../helper/getRange"));
const getSpectrum_1 = require("../helper/getSpectrum");
const DomainActions_1 = require("./DomainActions");
function handleChangeIntegralSum(draft, action) {
    const { options } = action.payload;
    const { data, view: { spectra: { activeTab: nucleus }, }, } = draft;
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    if (activeSpectrum?.id) {
        const { index } = activeSpectrum;
        const datum = data[index];
        (0, SumManager_1.setSumOptions)(datum.integrals, { options, nucleus });
        (0, Spectrum1D_1.updateIntegralsRelativeValues)(datum, true);
    }
}
exports.handleChangeIntegralSum = handleChangeIntegralSum;
function initiateIntergalSumOptions(datum, options) {
    const { molecules, nucleus } = options;
    datum.integrals.options = (0, SumManager_1.initSumOptions)(datum.integrals.options, {
        molecules,
        nucleus,
    });
}
function addIntegral(datum, options) {
    const { from, to } = options;
    const { x, re } = datum.data;
    const shiftX = (0, Spectrum1D_1.getShiftX)(datum);
    const integration = (0, ml_spectra_processing_1.xyIntegration)({ x, y: re }, { from, to, reverse: true });
    const integral = {
        id: (0, uuid_1.v4)(),
        originalFrom: from - shiftX,
        originalTo: to - shiftX,
        from,
        to,
        integral: integration,
        absolute: integration,
        kind: 'signal',
    };
    datum.integrals.values.push(integral);
}
function handleAddIntegral(draft, action) {
    const { startX, endX } = action.payload;
    const { data, molecules, view: { spectra: { activeTab: nucleus }, }, } = draft;
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    if (activeSpectrum?.id) {
        const [from, to] = (0, getRange_1.default)(draft, { startX, endX });
        const datum = data[activeSpectrum.index];
        addIntegral(datum, { from, to });
        initiateIntergalSumOptions(datum, { molecules, nucleus });
        (0, Spectrum1D_1.updateIntegralsRelativeValues)(datum);
        (0, DomainActions_1.setIntegralsYDomain)(draft, datum);
    }
}
exports.handleAddIntegral = handleAddIntegral;
function handleDeleteIntegral(draft, action) {
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    if (activeSpectrum) {
        const state = (0, immer_1.original)(draft);
        const { index } = activeSpectrum;
        const { id: integralID } = action?.payload || {};
        const datum = draft.data[index];
        if (!integralID) {
            datum.integrals.values = [];
        }
        else {
            const peakIndex = state.data[index].integrals.values.findIndex((p) => p.id === integralID);
            datum.integrals.values.splice(peakIndex, 1);
            (0, Spectrum1D_1.updateIntegralsRelativeValues)(datum);
        }
    }
}
exports.handleDeleteIntegral = handleDeleteIntegral;
function handleChangeIntegral(draft, action) {
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    const state = (0, immer_1.original)(draft);
    const { integral } = action.payload;
    if (activeSpectrum?.id) {
        const { index } = activeSpectrum;
        const originalDatum = state.data[index];
        const datum = draft.data[index];
        const { x, re } = originalDatum.data;
        const integralIndex = originalDatum.integrals.values.findIndex((i) => i.id === integral.id);
        if (integralIndex !== -1) {
            datum.integrals.values[integralIndex] = {
                ...integral,
                originalFrom: integral.from,
                originalTo: integral.to,
                absolute: (0, ml_spectra_processing_1.xyIntegration)({ x, y: re }, { from: integral.from, to: integral.to, reverse: true }),
            };
            (0, Spectrum1D_1.updateIntegralsRelativeValues)(datum);
        }
    }
}
exports.handleChangeIntegral = handleChangeIntegral;
function handleChangeIntegralsRelativeValue(draft, action) {
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    const { id, value } = action.payload;
    if (activeSpectrum?.id) {
        const { index } = activeSpectrum;
        (0, Spectrum1D_1.changeIntegralsRelative)(draft.data[index], { id, value });
    }
}
exports.handleChangeIntegralsRelativeValue = handleChangeIntegralsRelativeValue;
function handleChangeIntegralsSumFlag(draft) {
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    if (activeSpectrum) {
        const { index } = activeSpectrum;
        const integralOptions = draft.data[index].integrals.options;
        integralOptions.isSumConstant = !integralOptions.isSumConstant;
    }
}
exports.handleChangeIntegralsSumFlag = handleChangeIntegralsSumFlag;
function handleCutIntegral(draft, action) {
    const { cutValue } = action.payload;
    const spectrum = (0, getSpectrum_1.getSpectrum)(draft);
    const integrals = spectrum.integrals.values;
    for (let i = 0; i < integrals.length; i++) {
        const { to, from } = integrals[i];
        if (cutValue > from && cutValue < to) {
            integrals.splice(i, 1);
            addIntegral(spectrum, { from, to: cutValue });
            addIntegral(spectrum, { from: cutValue, to });
        }
    }
    (0, Spectrum1D_1.updateIntegralsRelativeValues)(spectrum);
    (0, DomainActions_1.setIntegralsYDomain)(draft, spectrum);
}
exports.handleCutIntegral = handleCutIntegral;
